<template>
  <!--全部分类展示-->

<mt-popup  v-model="popupVisible" position="left" class="top_wrapper0" :modal='false'>
  <div class='allClassifyWrapper'>
    <div class='allClassify'>
      <div class='allClassifyTop'>
        <div class='allClassifyTitle'>全部分类</div>
        <div class='icon_close_color' @click='showClassify'>
          <span class='icon icon-close '></span>
        </div>
      </div>
        <div class="allBox">
          <div class='electricityClassifyWrapper'>
            <div class='electricityClassifyName'>常用:</div>
            <div class='electricityClassifyContent' @click="getAjax(0,'')">
              <div class='electricityClassifyItem' >
                <img src="../../images/jx.png" class='electricityLogo'>
                <div class='electricityName'>精选</div>
              </div>
            </div>
            <div class=' electricityClassifyContent'>
              <div class="electricityClassifyItem" @click="getAjax(0,'new')">
                <div class='sponserCatalogItemAll'>最新</div>
                <div class='electricityName'>最新</div>
              </div>
            </div>
          </div>
          <div class='electricityClassifyWrapper'>
            <div class='electricityClassifyName'>外卖:</div>
            <div class='electricityClassifyContent'>
              <div class='electricityClassifyItem' v-for="item in allCatalogLists" v-if="item.catalogName=='外卖'" @click="getAjax(item.id,'new')">
                <img :src="item.logo" class='electricityLogo'>
                <div class='electricityName'>{{item.name}}</div>
                <div class='activityNum'>{{item.c}}</div>
              </div>
            </div>
          </div>
          <div class='electricityClassifyWrapper'>
            <div class='electricityClassifyName'>出行:</div>
            <div class='electricityClassifyContent'>
              <div class='electricityClassifyItem' v-for="item in allCatalogLists" v-if="item.catalogName=='出行'" @click="getAjax(item.id,'new')">
                <img :src="item.logo" class='electricityLogo'>
                <div class='electricityName'>{{item.name}}</div>
                <div class='activityNum'>{{item.c}}</div>
              </div>
            </div>
          </div>
          <div class='electricityClassifyWrapper'>
            <div class='electricityClassifyName'>网购:</div>
            <div class='electricityClassifyContent'>
              <div class='electricityClassifyItem' v-for="item in allCatalogLists" :key='item.id' v-if="item.catalogName=='网购'" @click="getAjax(item.id,'new')" >
                <img :src="item.logo" class='electricityLogo' >
                <div class='electricityName'>{{item.name}}</div>
                <div class='activityNum'>{{item.c}}</div>
              </div>
            </div>
          </div>
          <!--
          <div class='electricityClassifyWrapper'>
            <div class='electricityClassifyName'>快餐:</div>
            <div class='electricityClassifyContent'>
              <div class='electricityClassifyItem' v-for="item in  kcLists" :key='item.id' @click="getAjax(item.id,'new')">
                <img :src="item.logo" class='electricityLogo' >
                <div class='electricityName'>{{item.name}}</div>
                <div class='activityNum'>{{item.c}}</div>
              </div>
            </div>
          </div>
          -->
          <div class='electricityClassifyWrapper'>
            <div class='electricityClassifyName'>电影:</div>
            <div class='electricityClassifyContent'>
              <div class='electricityClassifyItem' v-for="item in allCatalogLists" :key='item.id' v-if="item.catalogName=='电影'" @click="getAjax(item.id,'new')">
                <img :src="item.logo" class='electricityLogo' >
                <div class='electricityName'>{{item.name}}</div>
                <div class='activityNum'>{{item.c}}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
    </div>
    </mt-popup>

</template>

<script>
import Vue from 'vue'
import { Popup } from 'mint-ui';
Vue.component(Popup.name, Popup);
export default {
  name:'welfareClassify',
  props:['popupVisible','getAjax','showClassify'],
  data () {
    return {
      allCatalogLists:[],
      kcLists:[]
    }
  },
  created () {
    this.login()
    this.kcLogin()
  },
  methods:{
    login () {
      this.url = "api/getAllCatalogList.php"
      //console.log(this.url)
      this.$ajax.autoService
          .login(this.url)
          .then((res) => {
            this.allCatalogLists = this.allCatalogLists.concat(res.data.map(function(item){
              return item
            }))
           //console.log(this.allCatalogLists)
          }, (res) => {
              console.log("error")
          })
     },
     kcLogin () {
       this.kcUrl = "api/getAllCatalogList.php"
       //console.log(this.kcUrl )
       this.$ajax.autoService
           .login(this.kcUrl )
           .then((res) => {
             this.kcLists = this.kcLists.concat(res.data.map(function(item){
               return item
             }))
            //console.log(this.kcLists)
            //console.log("this.kcLists")
           }, (res) => {
               console.log("error")
           })
      }
  }
}
</script>

<style lang="stylus">
.top_wrapper0
  width:100%
  height:100%
  position:fixed
  background: rgba(0,0,0,0.5)
  .allClassifyWrapper
    width: 100%
    height:100%
    overflow-y:auto
    position:relative
    .allClassify
      width: 630px
      background: #fff
      .allClassifyTop
        position:fixed
        left:0
        top:0
        width: 630px
        box-sizing: border-box
        height: 100px
        padding: 0 30px
        background: #f2f2f2
        line-height: 100px
        color: #333
        display: flex
        font-size: 0px
        z-index:10
        justify-content: space-between
        .allClassifyTitle
          font-size: 32px
        .icon_close_color
          font-size: 32px
          color: #666
          line-height: 100px
          height: 100px
          padding: 0px
          background: none
          width: 40px
          margin: 0px;
      .allBox
        background:#fff
        margin-top:100px
        position:relative
        z-index:1
        .electricityClassifyWrapper
          padding: 35px 30px 25px
          border-bottom: 1px solid #e5e5e5/*px*/
          display: flex
          .electricityClassifyName
            font-size: 28px
            color: #666
            flex: 0 0 100px
          .electricityClassifyItem
            display: inline-block
            width: 145px
            padding: 0px
            line-height: none
            background: none
            overflow: visible
            position:relative
            margin-bottom:20px
            .sponserCatalogItemAll
              width: 100px
              height: 100px
              background: linear-gradient(to right,#ff972b,#ff6108)
              border-radius: 20px
              font-size: 36px
              color: #fff
              line-height: 100px
              text-align: center
              margin: 0 auto
            .electricityLogo
              width: 100px
              height:100px
              display: block
              margin: 0 auto
            .electricityName
              font-size: 24px
              color: #333
              text-align: center
              margin-top: 20px
              line-height: 24px
            .activityNum
              position: absolute;
              top: -5px
              left: 100px
              width: 32px
              height: 32px
              border-radius: 50%
              background: #f00
              font-size: 20px
              line-height: 30px
              color: #fff
              padding-top: 2px
              box-sizing: border-box
              text-align:center

</style>



// WEBPACK FOOTER //
// src/components/welfare/welfareClassify.vue